/*
*
* File JS componente CONTENT BLOCKS
*
* In questo componente sono importati tutti i blocchi del contenuto flessibile "Page - content block"
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import blockImgText from 'components/block-img-text/block-img-text';
import blockHalfImgText from 'components/block-half-img-text/block-half-img-text';
import blockThreeColumn from 'components/block-three-column/block-three-column';
import blockTitleText from 'components/block-title-text/block-title-text';
import blockImage from 'components/block-image/block-image';
import blockImageSection from 'components/block-image-section/block-image-section';
import blockEmbed from 'imComponents/block-embed/block-embed';
import blockTitleList from 'components/block-title-list/block-title-list';
import blockHistory from 'components/block-history/block-history';
import blockTextCards from 'components/block-text-cards/block-text-cards';
import blockTextLogos from 'components/block-text-logos/block-text-logos';
import carouselGallery from 'imComponents/carousel-gallery/carousel-gallery';
import blockDownload from 'components/block-download/block-download';
import blockTabs from 'components/block-tabs/block-tabs';
import blockTeam from 'components/block-team/block-team';
import blockLogos from 'components/block-logos/block-logos';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './content-blocks.scss';
import blockOneColumn from "components/block-one-column/block-one-column";

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const contentBlocks = () => {
    blockHistory();
    carouselGallery();
    blockOneColumn();
    blockTabs();
}

export default contentBlocks;

//--------------------------------------------------------------------//